import { createAction } from 'redux-act';

const ActionTypes = {
    // 设置用户数据的UserInfo
    fnSetUserInfo: createAction('$$/User/fnSetUserInfo'),
};

export default ActionTypes;


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/redux/reducers/user/ActionTypes.ts